export default "__VITE_ASSET__CMR2IRcV__"